'use client'
export { StatusBar } from 'react-native'
